import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { AnimatePresence, motion } from "framer-motion";
import styled from "@emotion/styled";
import { useMediaQuery } from "react-responsive";

//style rules
import { Sizes, Typography, Colors } from "../../styles";
const placeholder = "/wp-content/themes/fords/dist/images/png/graphics/placeholder-lrg@2x.png";

const StorylineItems = ({ items, handleClick }) => {
	if (!items || !items.length) return null;

	const isDesktop = useMediaQuery({ query: `(min-width: ${Sizes.screens.medium})` });

	return (
		<TimelineWrapper>
			{items.map((item, index) => {
				const isIndexEven = index % 2 !== 0;
				const animationAmount = {
					initial: 100,
					final: 0,
				};

				if (isIndexEven && isDesktop) {
					animationAmount.initial = 220;
					animationAmount.final = 120;
				}

				return (
					<Card
						key={item.id}
						initial={{ opacity: 0, y: animationAmount.initial }}
						whileInView={{ opacity: 1, y: animationAmount.final }}
						transition={{ duration: 0.5 }}
						viewport={{ once: true, amount: isDesktop ? 0.8 : 0.2 }}
						tabIndex={0}
						onClick={() => {
							handleClick(item);
						}}
						aria-label={`open ${item.title} side panel`}>
						<AspectRatioBox>
							<Image src={item.image ? item.image : placeholder} alt={item.title ? item.title : "fords theatre logo"}></Image>
						</AspectRatioBox>
						<Subtitle>{item.subtitle}</Subtitle>
						<Title>{item.title}</Title>
						<Button role="button" aria-label={`open ${item.title} side panel`}>
							Learn More
						</Button>
					</Card>
				);
			})}
		</TimelineWrapper>
	);
};
StorylineItems.propTypes = {
	items: PropTypes.array,
	handleClick: PropTypes.func,
};

export default StorylineItems;

const TimelineWrapper = styled.div`
	margin: 5.6rem 0 12.25rem;
	display: flex;
	flex-direction: column;
	gap: 3.5rem;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		column-gap: 4.9rem;
		row-gap: 9.7rem;
		margin: 5.6rem 0 12rem !important;
	}
`;

const Card = styled(motion.div)`
	display: flex;
	flex-direction: column;
`;

const AspectRatioBox = styled.div`
	width: 100%;
	height: auto;
	position: relative;
	padding-top: calc(231 / 410 * 100%);
	overflow: hidden;
`;

const Image = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
`;

const Subtitle = styled.h4`
	font-size: 1.6rem;
	line-height: 1.9rem;
	margin-top: 1.6rem;
`;

const Title = styled.h3`
	font-size: 2.4rem;
	font-weight: ${Typography.fontWeight.regular};
	line-height: 3rem;
	margin-top: 0.8rem;
`;

const Button = styled.span`
	width: fit-content;
	margin-top: 1.6rem;
	border-radius: 30px;
	border: 0;
	color: ${Colors.base.white};
	background-color: ${Colors.base.red};
	display: inline-block;
	font-weight: ${Typography.fontWeight.regular};
	font-family: ${Typography.fontFamily.alt};
	text-align: center;
	font-size: 1.6rem;
	line-height: 1.8rem;
	padding: 1.2rem 3rem;
	white-space: nowrap;
	transition: all 0.1s ease-in-out 0.1s;
	cursor: pointer;

	&:hover,
	&:focus {
		color: palette(white);
		background-color: ${Colors.base.redDark};
		transform: scale(1.03);
		transition: all 0.1s ease-in-out 0.1s;
		box-shadow: 0 1px 1px 0 rgba(59, 72, 77, 0.08), 0 1px 3px 1px rgba(59, 72, 77, 0.16);
	}
`;
